import PropTypes from 'prop-types';

export default function InputErrorMessage({ id, message, className = "" }) {
  if (!message) {
    return null;
  }

  return (
    <div
      id={id}
      role="alert"
      aria-live="polite"
      className={`mt-2 flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 shadow-sm ${className}`}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M9.401 2.316a1.25 1.25 0 0 1 1.933 0l7.143 9.189c.62.797.045 1.995-.966 1.995H3.224c-1.011 0-1.586-1.198-.966-1.995l7.143-9.19Zm.599 4.184a.75.75 0 0 0-.75.75v3.75a.75.75 0 1 0 1.5 0V7.25a.75.75 0 0 0-.75-.75Zm0 7a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z"
          clipRule="evenodd"
        />
      </svg>
      <span>{message}</span>
    </div>
  );
}

InputErrorMessage.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
};

InputErrorMessage.defaultProps = {
  className: "",
};
